/* angular:styles/component:css;a575c02283b18b95c8da58b5b6573a4592b097e1284e775aef60d2923ca43cd6;/opt/atlassian/pipelines/agent/build/src/app/tabs/tabs.page.ts */
.hidden {
  display: none !important;
}
.main-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.charts-wrapper {
  flex-grow: 1;
  flex-basis: 0;
  min-height: 0;
  overflow-y: hidden;
}
viewfinder-chart {
  background-color: var(--ion-background-color);
  --background-color: var(--ion-background-color);
}
ion-title.center-title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  padding: 0;
}
@media (max-width: 576px) {
  ion-title.center-title {
    font-size: 0.9rem;
  }
}
/*# sourceMappingURL=tabs.page.css.map */
